import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AdminLogs } from '../../Models/Authentication/UserModel';
import { BaseApiService } from '../../Services/base-api.service';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';

interface DynamicContent {
  key: string;
  value: any;
}
@Component({
  selector: 'app-logs-application',
  templateUrl: './logs-application.component.html',
  styleUrls: ['./logs-application.component.css'],standalone:false
})
export class LogsApplicationComponent extends BaseComponent implements OnInit {
  loading:boolean=false;
  Users:AdminLogs[]=[];
  showTable:boolean=false;
  dynamicContentKeys: string[] = [];
  constructor
  (
    private messageService:MessageService,
    private api:BaseApiService
  )
  {
     super();
  }

  getUsers(){
    this.loading=true;
    this.api.read("AdminLogs")
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
    (
      {
         next:(response)=>{
          this.Users = response;
          this.Users =  this.Users.filter(x=>x.entityType!="LogsAdmin");
          this.Users = this.Users.map((log: AdminLogs) => ({ ...log, parsedContent: this.parseContent(log.content) }))
          this.loading=false;
        }
        ,error:(error)=>{
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error });
        }

      }
      

    )
  }
  parseContent(content: string): DynamicContent[] | null {
    try {
      const parsedContent = JSON.parse(content);
      return Object.keys(parsedContent).map(key => ({ key, value: parsedContent[key] }));
    } catch (error) {
      return null;
    }
  }

ngOnInit(): void {
  this.getUsers();
  if (this.Users.length > 0) {
    this.dynamicContentKeys = Object.keys(this.Users[0].content);
  }
}

}
